import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import "./index.css";
import { Dashboard } from "./pages/dashboard";
import { Settings } from "./pages/settings";
import { Timeline } from "./pages/timeline";
import { Providers } from "./providers";

import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { Privacy } from "./pages/privacy";
import { Terms } from "./pages/terms";

const firebaseConfig = {
  apiKey: "AIzaSyAAHT4wHk8aBtAJwEpfioQMTk9ZyoTWyd0",
  authDomain: "zeitfy---1.firebaseapp.com",
  projectId: "zeitfy---1",
  storageBucket: "zeitfy---1.firebasestorage.app",
  messagingSenderId: "370779869892",
  appId: "1:370779869892:web:48f0130de52c773f086f91",
  measurementId: "G-KT13LD7GEK",
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAnalytics = getAnalytics(firebaseApp);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Providers>
    <BrowserRouter>
      <Routes>
        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="*" element={<Layout />}>
          <Route path="settings/:pageId" element={<Settings />} />
          <Route path="settings" element={<Settings />} />
          <Route path="timeline" element={<Timeline />} />
          <Route path="*" element={<Dashboard />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </Providers>
);
